const supportedNotificationTypes = [
  'thread',
  'reply',
  'mention',
  'recording-added',
  'recording-failed',
  'new-member',
  'member-removed',
  'new-reaction',
];

const getLink = (data) => {
  switch (data.type) {
    case 'thread':
    case 'reply':
    case 'mention':
      return `/meetings/${data.recordingId}?threadId=${data.threadId}`;
    case 'recording-added':
      return `/meetings/${data.recordingId}`;
    case 'recording-failed':
      return `/meetings`;
    case 'new-reaction':
      return `/meetings/${data.recordingId}?utteranceIndex=${data.entityId}`;
    case 'new-member':
    case 'member-removed':
      return `/team`;
  }
};

const getTitle = (notification) => {
  switch (notification.type) {
    case 'thread':
      return 'New Comment';
    case 'reply':
      return 'New Reply';
    case 'recording-failed':
      return 'Processing failed';
    case 'recording-added':
      return 'New Meeting';
    case 'new-member':
      return 'New Member';
    case 'member-removed':
      return 'Member Removed';
    case 'new-reaction':
      return 'New Reaction';
    case 'mention':
      return 'New Mention';
  }
};

const getName = (notificationType) => {
  switch (notificationType) {
    case 'thread':
      return 'Comments';
    case 'reply':
      return 'Replies';
    case 'recording-failed':
      return 'Failed Meetings';
    case 'recording-added':
      return 'New Meetings';
    case 'new-member':
      return 'New Members';
    case 'member-removed':
      return 'Removed Members';
    case 'new-reaction':
      return 'Reactions';
    case 'mention':
      return 'Mentions';
  }
};

const getUserUid = (type, data) => {
  switch (type) {
    case 'thread':
    case 'reply':
      return data.addedBy;
    case 'mention':
      return data.mentionedBy;
    case 'recording-added':
      return data.addedBy;
    case 'recording-failed':
      return data.addedBy;
    case 'new-reaction':
      return data.addedBy;
    case 'new-member':
      return data.invitedBy;
    case 'member-removed':
      return data.removedBy;
  }
};

// const formatNotification = (notification) => {
//   switch (notification.type) {
//     case 'thread':
//       return {
//         name: 'Comment',
//         header: 'New Comment',
//         description: '',
//         actionedBy: '',
//         type: '',
//         isRead: false,
//         url: '',
//       };
//     case 'reply':
//       return {};
//     case 'mention':
//       return {};
//     case 'recording-added':
//       return {};
//     case 'recording-failed':
//       return {};
//     case 'new-reaction':
//       return {};
//     case 'new-member':
//       return {};
//     case 'member-removed':
//       return {};
//   }
// };

export { getLink, getTitle, getName, getUserUid, supportedNotificationTypes };
